export default __webpack_public_path__ + "static/media/promocionAlarma5Mobile.e82e2f72.png";